import { CSSProperties, Dispatch, SetStateAction, useState } from 'react';



import { Button } from '../Button';
import Drawer from '../Drawer';
import { IOptionsGroup } from '../Options';
import FilterOptions from './components/FilterOptions';
import { ICalendarOptions } from '../../utils/filterUtil';
import { useTranslation } from 'react-i18next';

/* eslint-disable no-unused-vars */
export interface IApplyedFilter {
  filter: FilterObjectExtended;
  action: (value: boolean) => void;
}

/* eslint-disable no-unused-vars */
export interface FilterObject {
  name: string,
  label?: string,
  onChange?: ((value: string | Date[] | undefined) => void) | ((value: string[] | Date[] | undefined) => void) | Dispatch<SetStateAction<string | undefined>>;
  optionsGroup: IOptionsGroup[]
  multiple: boolean
  calendarOptions?: ICalendarOptions
}

export interface FilterObjectExtended extends FilterObject {
  id?: number
  values: string | string[] | Date[]
}



export interface FilterProps {
  title: string
  description: string
  filtros: FilterObject[]
  style?: CSSProperties | undefined
}

export function Filter(props: FilterProps) {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const [applyedFilters, setApplyedFilters] = useState<IApplyedFilter[]>([])
  const [badge, setBadge] = useState<boolean>(false);


  let filters: FilterObjectExtended[] = props.filtros as FilterObjectExtended[];
  filters = filters.map((item, index) => ({
    ...item,
    id: index + 1,
  }));

  function handleCollapse(value: boolean) {
    return () => setCollapsed(value)
  }

  return (
    <div style={props.style}>
      <Button type='button' variant='tertiary' size='md' iconName='fluent:filter-12-filled' onClick={handleCollapse(true)} alertBadge={badge} iconPosition='right'>{t("Filtros")}</Button>
      <Drawer isOpen={collapsed} onClose={handleCollapse(false)}>
        <FilterOptions setClose={setCollapsed} setBadge={setBadge} applyedFilters={applyedFilters} setApplyedFilters={setApplyedFilters} title={props.title} description={props.description} filters={filters} />
      </Drawer>

    </div>
  )
}